<template>
  <div class="preferences">

    <div class="top-bar">
      <span @click="goBackToSalaryStructuresPage">
        <i class="left"></i>
      </span>
      <span class="heading_new">Add New Component </span>
      <span class="spacer" />
      <!-- <span @click="refresh" class="refresh-icon"><img src="@/assets/path-copy.svg" /></span> -->
    </div>

    <div class="main-container">
      <!-- prefrences form  -->
      <form action class="preferences-form">

        <div class="flex-container">
          <div>
            <txt label="Name *" type="text" v-model="formData.name" name="Name" :classname="errors.has('Name')" v-validate="'required'"
              :errormsg="errors.first('Name')" />
          </div>
          <div>
            <txt label="Abbreviation *" type="text" name="Abbrevation" v-model="formData.abbrevation" :classname="errors.has('Abbrevation')"
              v-validate="{required: true, max: 30}" :errormsg="errors.first('Abbrevation')" />
          </div>
          <div class="">
            <span class="input-label">Effective Date</span>
            <date-picker @datevalue="(val)=>formData.effectiveDate=val" :value="formData.effectiveDate" name='Effective Date' :classname="errors.has('Effective Date')"
              v-validate="'required'" :errormsg="errors.first('Effective Date')" />
          </div>
          <div class="">
            <!-- {{formData.roundOff}} -->

            <tl-select label="Round off" labelText="country" :options="roundOffData" v-model="formData.roundOff" @change="(val)=>formData.roundOff = val"
              name="Round Off" :classname="errors.has('Round Off')" v-validate="'required'" :errormsg="errors.first('Round Off')"></tl-select>

          </div>
        </div>
        <!-- name & abbreviation effective date && Round off Value -->


        <div class="flex-container">
          <!-- Map to -->
          <div class="selectdiv">
            <div class="input-label">Map To</div>
            <select v-model="formData.mapTo" class="dropdown" name="ParentBU">
              <option v-for="(type, index) in mapToData" :key="index" :value="type.id">{{type.name}}</option>
            </select>
          </div>
          <!-- Map to -->

          <!-- Pay Type -->

          <div class="">
            <tl-select class="" label="Pay Type" :options="payTypeData" :value="formData.payType" @change="(val)=>formData.payType = val"></tl-select>
          </div>

          <div class="add-new-flex-basis">
            <div class="input-label">Tax Status</div>
            <div class="twoColumnGrid">
              <div class="radio-group">
                <input type="radio" id="Taxable" name="isTaxable" v-bind:value="true" v-model="formData.isTaxable">
                <label for="Taxable">Taxable </label>
              </div>
              <div class="radio-group ">
                <input type="radio" id="NonTaxable" name="isTaxable" v-bind:value="false" v-model="formData.isTaxable">
                <label for="NonTaxable">Non Taxable </label>
              </div>
            </div>



            <div class="check marginleft-30 radio-margin-top">
              <tl-checkbox class="headcheck" label="Tax is distributed across the year" v-bind:disable="!formData.isTaxable" v-model="formData.isTaxDistributed"
              />
            </div>

          </div>


        </div>

        <div class="flex-container">
          <div class="">
            <div class="label-text">Component Type</div>
            <div class="radio-group radio-margin-top">
              <input type="radio" id="Fixed" name="fixedOrVariable" value="Fixed" v-model="formData.fixedOrVariable">
              <label for="Fixed">Fixed </label>
              <input type="radio" id="Variable" name="fixedOrVariable" value="Variable" v-model="formData.fixedOrVariable ">
              <label for="Variable">Variable </label>
            </div>
          </div>
        </div>


        <div class="flex-container">
          <div>
            <tl-select class="" label="Calculation Type" :options="calculationTypeData" :value="formData.calculationType" @change="(val)=>formData.calculationType = val"></tl-select>
          </div>
          <div>
            <tl-select class="" label="Calculation On" :options="calculationOnData" :value="formData.calculationOn" @change="(val)=>formData.calculationOn = val"></tl-select>
          </div>
          <div>
            <div class="label-text">Value / Formula</div>
            <div class="selectdiv">
              <textarea class="form-control" name="calculation" v-model="formData.calculation" />
            </div>
            <div class="" v-if="formData.calculationType === 'Formula' || formData.calculationType === 'Slabwise'">
              <p class="anc-paragraph" @click="generateFormula">Generate Formula</p>
            </div>
          </div>
        </div>


        <div class="margin-12px ">


        <div class="label">
          <h4 class="form-sub-header">Other Settings</h4>
        </div>

        <!-- Other Settings -->

        <div class="threeColumnGrid label">


          <tl-checkbox class="headcheck" label="Is an FBP Component" v-model="formData.isFBP" />

          <tl-checkbox class="headcheck" label="Part of CTC" v-model="formData.isPartOfCTC" />

          <tl-checkbox class="headcheck" label="Active" v-model="formData.isActive" />



          <tl-checkbox class="headcheck" label="Create Dependent Component" v-model="formData.isDependent" />

          <tl-checkbox class="headcheck" label="Is an FFS component" v-model="formData.isFFS" />
          <tl-checkbox class="headcheck" label="Paid Component" v-model="formData.isPaid" />


          <div class="">
            <tl-checkbox class="headcheck" label="Not dependent on Attendance" v-model="formData.isAttendanceDependent" />


            <div class="flex-container flex-basis-auto">
              <tl-checkbox class="headcheck marginleft-10p margintop-20" label="Payable even if absent full month" v-model="formData.ifAbsentFullMonth"
                v-bind:disable="!formData.isAttendanceDependent" />
            </div>

            <div class="flex-container flex-basis-auto">
              <tl-checkbox class="headcheck marginleft-20p margintop-10" label="Payable only if joined after" v-bind:disable="!formData.isAttendanceDependent"
              />
              <tl-select class="custom-width-100 no-label" :options="joinedAfterData" :value="formData.ifJoinedAfter" @change="(val)=>formData.ifJoinedAfter = val"
                v-bind:disable="!formData.isAttendanceDependent"></tl-select>
            </div>
          </div>
          <div>
            <tl-checkbox class="headcheck" label="Reflect this component in payslip" v-model="formData.inPayslip" />
          </div>
          <div>
            <tl-checkbox class="headcheck" label="Gross up tax" v-model="formData.isGrossupTax" />
          </div>

          <!-- Consider of ESI -->
          <div class="">
            <tl-checkbox class="headcheck" name="isESIEligible" label="Consider for ESI Eligibility" v-model="formData.isESIEligible"
            />
          </div>
          <div class="">
            <tl-checkbox class="headcheck" name="isESIDeduction" label="Consider for ESI Deduction" v-model="formData.isESIDeduction"
            />
          </div>
          <div class="">
            <tl-select class="custom-width" label="Pay Frequency" :options="payFrequency" :value="formData.payFrequency" @change="(val)=>formData.payFrequency = val"></tl-select>
          </div>

        </div>
        <!-- Consider of ESI -->


        <!-- Deductions -->
        <section class="">

          <div class="label-text label-text-header ">Deductions{{formData.deduction}}</div>
          <div class="twoColumnGrid label">
            <tl-radio name="deduction" label="Chapter VI A" id="deduction1" value="chapter6a" v-model="formData.deduction" :checked="'this.chapter6aOptions'" />
            <tl-radio name="deduction" label="Section 10" id="deduction2" value="section10" v-model="formData.deduction" />
            <tl-radio name="deduction" label="Section 17" id="deduction3" value="section17" v-model="formData.deduction" />
            <tl-select v-show="formData.deduction !== null" label="Map To" :placeholder="'select'" :value="formData.deductionSelect" :options="deductionOptions"
              @change="(val)=>formData.deductionSelect = val" />

          </div>

        </section>
        <!-- Deductions -->
        <!-- Other Settings -->

      </div>

      </form>
      <br>
      <br>
      <!-- //advance button -->


      <div class="btn-group">
        <!--bottom action button-->
        <bottom-action-container>
          <btn-grp slot="end">
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn text="Add New Component" type="primary" @click="save" />
          </btn-grp>
        </bottom-action-container>
      </div>
    </div>


    <pop-up-message v-if="showSuccessMsg" :message="`New Salary Component has been successfully added.`" btnText="Back" @back="backfrompopup()"
    />


    <!-- creat formula modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Create Formula</h3>
        </div>
        <div class="modal-body">
          <div class="threeColumnGrid spacing">

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" labelText="Brackets" label="bracket" :options="bracketsData" :reduce="bracket => bracket"
                :value="formData.brackets" @change="brackets($event)"></tl-select>
            </div>

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" label="Abbreviation" :options="abbreviationData" :value="formData.abbreviation"
                @change="abbreviation($event)"></tl-select>
            </div>

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" label="Operators" :options="operatorsData" :value="formData.operators"
                @change="operators($event)"></tl-select>
            </div>

          </div>

          <div class="twoColumnGrid">
            <div>
              <textarea class="form-control width-100" v-model="finalFormula"></textarea>
            </div>

            <div class="justify-content-center text-center" v-show="afterSavingExpression">
              <div v-show="isValidExpression">
                <img src="@/assets/checked.svg" class="status-image" alt="check">
                <p class="status-text margintop-20">Valid Expression</p>
              </div>
              <div v-show="!isValidExpression">
                <img src="@/assets/warning_error.svg" class="status-image" alt="warning_error">
                <p class="status-text margintop-20 color-red">Invalid Expression</p>
              </div>
            </div>
          </div>
          <div class="margintop-10">
            <p class="anc-paragraph" @click="onValidExpression()">Validate</p>
          </div>
          <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelModal" />
              <btn :text="saveBtnText" type="primary" @click="saveExpression" :disabled="!isValidExpression" />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex';
  export default {
    name: "AddNewSalaryComponent",
    props: {
      mode: {
        type: String,
        default: 'add'
      },
      compData: {
        type: Object,
        default: null
      }
    },
    computed: {
      ...mapActions({
        act_fetch_component_types: 'onboard/settings/salary_component_types/fetchAll',
      }
      ),
      ...mapState({
        componentTypes: state => state.onboard.settings.salary_component_types.data,
        salaryComponentsData: state => state.onboard.settings.salary_component.entityWiseData
      }),
      ...mapGetters({
        getLegalEntityId: 'onboard/legal_entities/legal_entity_ID'
      }),
      leId() {
        if (this.$route.params.entity_index) {
          return this.getLegalEntityId(this.$route.params.entity_index);
        }
        return this.getLegalEntityId(0);
      },
      orgId() {
        return this.$store.getters['onboard/organization/orgid']

      },
      saveBtnText() {
        return !this.$route.query.id ? 'Save' : 'Update';
      },
      deductionOptions() {
        if (this.formData.deduction == 'chapter6a') {
          return this.chapter6aOptions;
        }
        else if (this.formData.deduction == 'section10') {
          return this.section10Options;
        }
        else {
          return [];
        }
      },
      mapToData() {
        // let newList = [];
        // let mapToList = {};
        // if(this.salaryComponentsData[this.leId])
        // this.salaryComponentsData[this.leId].forEach((type) => {
        //    mapToList[type.name]=type.id;
        //    newList.push(type.name)
        // });
        // return newList;
        return this.salaryComponentsData[this.leId];
      },
      abbreviationData() {
        let newAbbreviationData = ['HRA', 'BASIC'];
        if (this.salaryComponentsData[this.leId])
          this.salaryComponentsData[this.leId].forEach((type) => {
            newAbbreviationData.push(type.abbrevation)
          });
        return newAbbreviationData;
      }
    },
     mounted() {
      this.formData.deduction = "chapter6a";
    },
    activated() {
      this.formData.deduction = "chapter6a";
      //console.log('query id', this.$route.query.id)
      if (this.$route.query.id)
        this.formData = this.$_.cloneDeep(this.$route.query.id)
    },
    data() {
      return {
        afterSavingExpression: false,
        isValidExpression: false,
        joinedAfterData: Array.from(Array(31), (x, index) => index + 1),
        show: false,
        arrowUp: false,
        showSuccessMsg: false,
        showCreateModal: false,
        cityDataSelected: { code: 'CAdd', country: 'Canddada' },
        cityData: [{ code: 'CA', country: 'Canada' }, { code: 'CAdd', country: 'Canddada' }],
        roundOffData: ['Nearest to 1 Rs', 'Nearest to 50 Paisa', 'Nearest to 5 rs', 'None', 'Nearest to 10 rs', 'Round up'],
        payFrequency: ['Monthly', 'Quarterly', 'Weekly', 'Daily'],
        payTypeData: ['Deductions', 'Earnings', 'Reimbursement', 'Statutory'],
        calculationTypeData: ['Formula', 'Flat', 'Slabwise'],
        calculationOnData: ['Deducted', 'Actual'],
        formData: {
          name: null,
          abbrevation: null,
          calculation: null,
          calculationOn: null,
          calculationType: null,
          effectiveDate: null,
          fixedOrVariable: "Fixed",
          ifAbsentFullMonth: false,
          ifJoinedAfter: null,
          inPayslip: false,
          is6a: false,
          mapTo: null,
          isActive: false,
          isAttendanceDependent: false,
          isDependent: false,
          isESIDeduction: false,
          isESIEligible: false,
          isFBP: false,
          isFFS: false,
          isGrossupTax: false,
          isPaid: false,
          isPartOfCTC: true,
          isSection10: false,
          isTaxDistributed: false,
          isTaxable: false,
          payFrequency: null,
          payType: null,
          roundOff: null,
          deduction: "chapter6a",
          deductionSelect: null
        },
        finalFormula: '',
        blankFormData: {
          'name': '',
          'abbrevation': '',
          'effectiveDate': new Date(),
          'payType': '',
          'isTaxable': false,
          'isTaxDistributed': false,
          'calculationType': '',
          'calculation': '',
          'calculationOn': '',
          'mapTo': null,
          'roundOff': '',
          'fixedOrVariable': '',
          'isPaid': false,
          'isFBP': false,
          'isPartOfCTC': false,
          'isActive': false,
          'isFFS': false,
          'isDependent': false,
          'isAttendanceDependent': false,
          'ifAbsentFullMonth': false,
          'ifJoinedAfter': 0,
          'inPayslip': false,
          'isESIEligible': false,
          'isESIDeduction': false,
          'isGrossupTax': false,
          'payFrequency': null,
          'is6a': false,
          'isSection10': false,
          'legalEntityId': null, //uuid
          'deduction': null,
          'deductionSelect': null
        },
        bracketsData: ['(', ')', '[', ']', '{', '}'],
        operatorsData: ['+', '-', '*', '%', '/', ')'],
        chapter6aOptions: [
          '80C : 5 Years Fixed Deposit',
          '80C : 80CCC-Premium Paid for Annuity Plan of LIC or Other Insurer',
          '80C : 80CCD1-National Pension Scheme',
          '80C : Equity Linked Savings Scheme',
          '80C : Infratstructure Bond',
          '80C : LIC Deduction Through Salary',
          '80C : Life Insurance Premium',
          '80C : Mutual Funds',
          '80C : National Savings Certificate',
          '80C : National Savings Scheme',
          '80C : Pension linked Insurance',
          '80C : Post office fixed deposit schemes',
          '80C : Previous Employer 80C',
          '80C : Principal Repayment On Home Loan',
          '80C : Provident Fund',
          '80C : Public Provident Fund',
          '80C : Senior citizen savings scheme',
          '80C : Stamp Duty on House Property',
          '80C : Sukanya Samriddhi Scheme',
          '80C : Systematic Investment Plan',
          '80C : Tution Fee',
          '80C : Unit Linked Insurance Plan',
          '80C : Voluntary Provident Fund',
          '80CCD(2) : Template Contribution to NPS by Employer 10% of Basic Salary',
          '80CCD-1B : Additional contribution to NPS',
          '80CCG : RGESS (50% of the investment)',
          '80D : Medical Insurance Dependent',
          '80D : Medical Insurance for Senior Citizen',
          '80D : Medical Insurance Premium Paid Through Salary',
          '80D : Medical Insurance Self',
          '80D : Preventive Medical Checkup',
          '80DD : Maint. & Medi treatment for Physical disability',
          '80DD : Medical Treatment Expenses',
          '80DD : Medical treatment for severe disability',
          '80DDB : Med Treatment Exp. for Spec.disease Sr Citizen',
          '80DDB : Med Treatment Expenses Spec diseases',
          '80DDB : Med.Treatment Exp. for Spec.disease very Senior Citizen',
          '80E : Interest on Education Loan',
          '80EE : Interest on Home Loan Availed in 2016',
          '80G : Donation',
          '80TTA : Interest on Savings Account',
          '80TTB : Interest on Saving Account Sr Citizen',
          '80U : Person With Normal Disability',
          '80U : Person With Severe Disability',
          'Other Income: Interest on housing loan'
        ],
        section10Options: [
          'Leave Encashment',
          'LTA',
          'HRA',
          'Gratuity',
          'Telephone reimbursement',
          'Food coupons',
          'Vehicle maintenance reimbursement',
          'Driver salary',
          'Children education allowance',
          'Hostel fee allowance',
          'Uniform allowance',
          'Relocation allowance',
          'Petrol reimbursement',
          'Internet Expenses Reimbursement',
          'Professional development',
          'Periodical journals',
          'Business Entertainment',
          'Personality development',
          'Misc. Reimbursement',
          'Helper Allowance'
        ]
      };
    },

    methods: {
      ...mapActions({
        act_create: 'onboard/settings/salary_component/create',
        act_update: 'onboard/settings/salary_component/update',

      }),

      refresh() {
        this.formData.deduction = "chapter6a";
        this.formData = this.$_.cloneDeep(this.blankFormData);
        this.$validator.reset();
      },
      toggle() {
        event.preventDefault();
        if (this.show == false) {
          this.show = true;
          this.arrowUp = true;
        } else {
          this.show = false;
          this.arrowUp = false;
        }
      },
      goBack() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
        });
      },
      goBackToSalaryStructuresPage() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarystructure`
        });
      },
      async performAction() {
        try {
          this.$root._data.isSaving = true;
          await this.act_create({
            data: [this.formData],
            le_id: this.leId
          });
          setTimeout(() => {
            this.showSuccessMsg = true;
            this.refresh();
            this.$root._data.isSaving = false;
          }, 500);

        } catch (err) {
          this.$root._data.isSaving = false;
          //console.log(err);
        }
      },
      async save() {
        this.$validator.validateAll()
          .then((result) => {
            if (result) {
              //console.log('perform signup', result)
              this.performAction();
            }
          })

      },
      async saveExpression() {
        if (this.isValidExpression) {
          this.formData.calculation = this.finalFormula.replace(/'/g, "");
          this.cancelModal()
        }
      },
      cancelModal() {
        this.showCreateModal = false;
      },
      generateFormula() {
        this.showCreateModal = true;
      },

      async fetchComponentTypes() {
        try {
          await this.act_fetch_component_types;
        } catch (err) {
          //console.log(err);
        }
      },
      backfrompopup() {
        this.showSuccessMsg = false
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarystructure`
        });
      },



      onValidExpression() {

        try {
          let stringFinalFormula = this.finalFormula.toString();
          let result = eval(stringFinalFormula);
          //console.log(result);
          this.afterSavingExpression = true;
          this.isValidExpression = true;
        } catch (error) {
          //console.log(error);
          this.afterSavingExpression = true;
          this.isValidExpression = false;
        }

      },
      brackets(event) {
        //console.log(event.toString());
        this.finalFormula += event.toString();
      },
      abbreviation(event) {
        let addQuotes = "" + event.toString() + ""
        this.finalFormula += addQuotes;
      },
      operators(event) {
        this.finalFormula += event.toString();
      },

    },

  };
</script>




<style lang="scss" scoped>
  .margin-top-28 {
    margin-top: 28px;
  }

  .custom-width {
    width: 300px;
  }

  .custom-width-100 {
    width: 100px;
  }

  .preferences {
    width: 100%;
  }

  .label {
    width: 100%;
    margin-top: 30px;
  }

  .horiz-line {
    border-bottom: 1px solid #bababa;
    flex-grow: 1;
  }

  .preferences-label {
    font-family: Montserrat;
    font-size: 14px;
    color: #1f1f1f;
    margin-bottom: 4px;
  }

  .preferences-form .input-field {
    width: 224px;
    height: 35px;
    margin-top: 5px;
    border: 1px solid #8b9c9c;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #ffffff;
    outline: 0;
    color: #000000;
  }

  .advance-button {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    color: #34c0be;
  }

  .inline {
    display: flex;
    width: 100%;
    align-items: flex-end;
  }

  .inline img {
    height: 9px;
    width: 10px;
    margin: 0px 6px;
  }

  .check {
    display: flex;
    align-self: center;
  }

  .checkbox-line {
    display: flex;
    align-self: center;
  }

  .checkmark {
    border-radius: 4px;
  }

  .arrow-up img {
    transform: rotate(180deg);
  }

  .top-bar {
    // height: 70px;
    padding: 20px;
    background-color: #34c0be;
    display: flex;
  }

  .heading_new {
    font-family: Montserrat;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
    width: auto !important;
  }

  .left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 20px;
  }

  .radio-margin-top {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .custom-selectdiv-width {
    &.selectdiv {
      select {
        width: 137px !important;
      }
    }
  }

  select {
    width: 100%;
  }

  .flex-container {
    display: flex;
  }

  .flex-container>div {
    margin-left: 10px;
    margin-right: 10px;
    flex-basis: 222px;

  }

  .flex-container {
    &.flex-basis-auto>div {
      flex-basis: auto;
    }
    .add-new-flex-basis {
      flex-basis: 444px;
    }
  }

  .business .top-bar {
    height: auto;
    padding: 20px;
    background-color: #34c0be;
    display: flex;
  }

  .heading_new {
    width: 270px;
    font-family: Montserrat;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
    height: auto;
  }

  .selectdiv select {
    width: 300px;
    height: 35px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: black;
    border: 1px solid #a7a7a7;
    padding: 0 10px;
    /* needed */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    /* background: url("../../../../../../assets/stroke-1.png"); */
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    &:focus {
      outline: none;
      border: 2px solid #37c6c0;
    }
  }

  select .dropdown {
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    width: 93px;
    height: 35px;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
      outline: none;
      border: 2px solid #37c6c0;
    }
  }

  .radio-button-section {
    display: flex;
  }

  .modal-custom-width-select {
    width: 130px;
  }

  .main-container {
    padding: 30px 10px;
  }

  .tl-select-dropdown {
    margin-bottom: 0px;
  }

  .margin-12px {
    margin: 12px;
}

</style>
